import Vue from 'vue';
import Component from 'vue-class-component';
import ConfigurableSettingView from "@/views/settings/ConfigurableSettingView";
import {MeasureUnitKey} from "@/components/properties/settings/measure-units/model/MeasureUnitKey";
import {DimensioningModeKey} from "@/components/properties/settings/dimensions/model/DimensioningModeKey";
import {ItemHighlightingMode} from "@/components/properties/settings/dimensions/model/ItemHighlightingMode";

@Component({
  components: {ConfigurableSettingView},
  computed: {
    ItemHighlightingMode() {
      return ItemHighlightingMode;
    },
    DimensioningModeKey() {
      return DimensioningModeKey;
    },
    MeasureUnitKey() {
      return MeasureUnitKey;
    },
  }
})
export default class DimensionsSettingsView extends Vue {
}
